<div class="dark:bg-[#27272A]">
  <p-toast></p-toast>
  <router-outlet></router-outlet>
 @if (showScrollTop) {
     <div
    
    (click)="scrollToTop()"
    class="fixed scroll-top-btn  bottom-8 right-8 w-10 h-10 hover:scale-105 shadow-lg  dark:shadow-[#FFA3B9] shadow-[#A6252A] flex items-center justify-center rounded-full cursor-pointer transition-colors duration-300
           bg-[#A6252A] text-white
           dark:bg-[#FFA3B9]">
     <i class="pi pi-arrow-up"></i>
  </div>
 }

</div>

